import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SystemConfigurationService } from '@gms/user-api';
import {
  fetchMfaConfig,
  fetchMfaConfigFailure,
  fetchMfaConfigSuccess,
  saveMfaConfig,
  saveMfaConfigFailure,
  saveMfaConfigSuccess,
} from './mfa-config.actions';
import { MfaConfigOptions } from './mfa-config.state';

@Injectable({ providedIn: 'root' })
export class MfaConfigEffects {
  constructor(private _actions$: Actions, private _systemConfigService: SystemConfigurationService) {}

  fetchMfaConfig$: Observable<any> = createEffect(() =>
    this._actions$.pipe(
      ofType(fetchMfaConfig),
      switchMap(() =>
        this._systemConfigService.getMfaOptionsAdmin().pipe(
          map((response) => {
            const mfaConfig: MfaConfigOptions = {
              authenticatorEnabled: (response as any).authenticatorEnabled ?? false,
              smsEnabled: (response as any).smsEnabled ?? false,
              rememberDeviceEnabled: (response as any).rememberDeviceEnabled ?? false,
            };
            return fetchMfaConfigSuccess({ mfaConfig });
          }),
          catchError((error) => of(fetchMfaConfigFailure({ error })))
        )
      )
    )
  );

  saveMfaConfig$: Observable<any> = createEffect(() =>
    this._actions$.pipe(
      ofType(saveMfaConfig),
      switchMap((action) => {
        // Build API request body
        const requestBody = {
          AuthenticatorEnabled: action.mfaConfig.authenticatorEnabled,
          SmsEnabled: action.mfaConfig.smsEnabled,
          RememberDeviceEnabled: action.mfaConfig.rememberDeviceEnabled,
        };
        return this._systemConfigService.putMfaOptions(requestBody as any).pipe(
          map(() => saveMfaConfigSuccess()),
          catchError((error) => of(saveMfaConfigFailure({ error })))
        );
      })
    )
  );
}
